<script lang="ts">
  import { getContext } from 'svelte';
  import { css } from '@agapi/ui/panda/css';
  import { carouselStyles } from '../carousel.styles';
  import type { CarouselSlideProps } from '../carousel.types';

  const { fullWidth, children, css: cssProp }: CarouselSlideProps = $props();

  getContext<{ count: number }>('carousel').count++;

  const classes = carouselStyles.raw({ fullWidth });
</script>

<div class={css(classes.slide, cssProp)}>
  {@render children?.()}
</div>
